var map = {
	"./": 95117,
	"./create-sample": 1004,
	"./create-sample.js": 1004,
	"./embed-sample": 31527,
	"./embed-sample.js": 31527,
	"./index": 95117,
	"./index.js": 95117,
	"./mcp-sample": 58004,
	"./mcp-sample.js": 58004,
	"./responses-sample": 33336,
	"./responses-sample.js": 33336,
	"./showcases": 22867,
	"./showcases.js": 22867,
	"./visual-components": 51666,
	"./visual-components.js": 51666,
	"./webhooks-sample": 6482,
	"./webhooks-sample.js": 6482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70917;